import { render } from "./HostFileDownloadTesting.vue?vue&type=template&id=5e642b52"
import script from "./HostFileDownloadTesting.vue?vue&type=script&lang=js"
export * from "./HostFileDownloadTesting.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__